import { HttpLink } from '@apollo/client/link/http';

import { GRAPHQL_URL } from '@/api/config';

/**
 * Терминальный link для запросов и мутаций. Файлы идут не сюда, а в REST (src/api/rest).
 * `credentials: 'include'` — чтобы браузер отправлял и принимал refresh-куку бэкенда,
 * когда API на другом origin.
 */
export const httpLink = new HttpLink({
  uri: GRAPHQL_URL,
  credentials: 'include'
});
